import { render, staticRenderFns } from "./DailyCheckCommentHistoryIndex.vue?vue&type=template&id=525d5e88&"
import script from "./DailyCheckCommentHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./DailyCheckCommentHistoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports